import React, {useState} from 'react';

const AddItem = (props)=>{

    const [error, setError] = useState('');

    const onFormSubmit = (e)=>{
        setError('');
        e.preventDefault()
        const item = e.target.item.value;
        if(verify(item)){
            return
        }
        props.setItems([...props.items, item])
        e.target.item.value = '';
    }

    const verify = (item)=>{
        const exists = props.items.find(i=>i.trim()===item.trim())
        if(exists){
            setError('Item already exists')
            return true;
        }
        if (item.trim()===''){
            setError('Please enter valid item')
            return true;
        }
        return false
    }

    return(
        <div className = "react-list-items-form-container">
            {error && <p className = "react-list-items-form-error">{error}</p>}
            <form onSubmit={onFormSubmit} className = "react-list-items-form">
                <input type="text" name="item" className = "react-list-items-input"/>
                <button className = "react-list-items-btn">Add</button>
            </form>
        </div>
    )
}

export default AddItem




